import styled from "styled-components"
import { Box } from "../elements/Box"

interface IQuestionProps {
  multiselect?: boolean
  number: number
  text: string
}

const QuestionNumber = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fontFamilyEN};
  font-size: clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem);
`

const Container = styled.legend`
  display: flex;
  gap: clamp(0.75rem, 0.65rem + 0.5vw, 1.25rem);
  margin-bottom: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);

  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 140%;
`

const QuestionText = styled.span`
  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);
`
const MultiselectText = styled.span`
  display: block;
  margin-block-start: 0.1em;

  font-size: 0.75rem;
  font-size: clamp(0.75rem, 0.7rem + 0.25vw, 1rem);
  font-weight: 400;
  letter-spacing: 0.04em;
`

const Question = (props: IQuestionProps) => {
  const { multiselect, number, text } = props
  return (
    <Container>
      <QuestionNumber>Q{number}</QuestionNumber>
      <Box
        alignItems="flex-start"
        justifyContent="flex-start"
        flexDirection="column"
      >
        <QuestionText>{text}</QuestionText>
        {multiselect && <MultiselectText>(複数選択可能)</MultiselectText>}
      </Box>
    </Container>
  )
}

export { Question }
